import { cn } from "@punchup/utils/cn";

export default function SubHeader2({
  children,
  className,
  responsive,
}: {
  children: React.ReactNode;
  className?: string;
  responsive?: boolean;
}) {
  const fontSize = responsive ? "text-xl md:text-2xl" : "text-2xl";
  return (
    <h4 className={cn("font-semibold", fontSize, className)}>{children}</h4>
  );
}
